const translations = {
  "en": {
    "/yr": "/yr"
  },
  "zh-tw": {
    "/yr": "每年"
  }
};

export default translations;
